module.exports = __webpack_public_path__ + "static/img/ARAS1000_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAS1000_1.png
// module id = 7ASM
// module chunks = 0